import { render, staticRenderFns } from "./LocationsAwaitingApproval.vue?vue&type=template&id=7744826c"
import script from "./LocationsAwaitingApproval.vue?vue&type=script&lang=js"
export * from "./LocationsAwaitingApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports